/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import GreenLem from "./lems/GreenLem";
import BlueLem from "./lems/BlueLem";
import OrangeLem from "./lems/OrangeLem";

export interface OnBoardingScreensProps {
  startScreens: boolean;
}

export interface OnBoardingScreensState {
  realIndex: number;
}

const onBoardingScreens = [
  {
    title: "Mes données personnelles",
    text: "Retrouvez vos documents administratifs et autres affichages obligatoires.",
    image: "/images/onBoarding/screen1.png",
    lem: GreenLem,
    cardImage: "/images/onBoarding/card1.png",
  },
  {
    title: "Mes congés",
    text: "Consultez et gérez vos congés et  RTT.",
    image: "/images/onBoarding/screen2.png",
    lem: BlueLem,
    cardImage: "/images/onBoarding/card2.png",
  },
  {
    title: "Mes communautés",
    text: "Un espace dédié à l’échange entre collaborateurs.",
    image: "/images/onBoarding/screen3.png",
    lem: OrangeLem,
    cardImage: "/images/onBoarding/card3.png",
  },
];

export default class OnBoardingScreens extends React.Component<
  OnBoardingScreensProps,
  OnBoardingScreensState
> {
  private _swiperRef: any = undefined;
  private _swiper: any;

  constructor(props: OnBoardingScreensProps) {
    super(props);
    this.state = {
      realIndex: 0,
    };
  }

  public componentDidMount() {
    this._swiper = new Swiper(this._swiperRef, {
      slidesPerView: 1,
      effect: "fade",
      cssMode: true,
    });

    this._swiper.on("slideChange", () => {
      console.log(
        "slide changed",
        this._swiper.activeIndex,
        this.state.realIndex
      );

      this.setState({ realIndex: this._swiper.realIndex });
    });
  }

  render() {
    return (
      <div
        className={`onBoardingScreens ${
          this.props.startScreens ? "active" : ""
        }`}
      >
        {this._renderScreenImage()}
        {this._renderScreenLem()}
        <div className="onBoardingCards">
          {this._renderScreenCardIamge()}

          <div
            className="swiper-container swiperContainer"
            ref={(e) => (this._swiperRef = e)}
          >
            <div className="swiper-wrapper">{this._renderScreenText()}</div>
            <div className="swiperPagination">
              {this._renderPaginationBullets()}
            </div>
          </div>

          <div
            className="understandButton"
            onClick={(e) => {
              this.state.realIndex === onBoardingScreens.length - 1
                ? this._hideOnBoarding()
                : this._swipeToNext();
              e.stopPropagation();
            }}
          >
            {this.state.realIndex === onBoardingScreens.length - 1
              ? "j’ai compris"
              : "Suivant"}
          </div>
        </div>
      </div>
    );
  }

  private _renderScreenText() {
    return onBoardingScreens.map((item, index) => (
      <div className="swiper-slide swiperContainer" key={index}>
        <div className="title">{item.title}</div>
        <div className="text">{item.text}</div>
      </div>
    ));
  }

  private _renderScreenImage() {
    return onBoardingScreens.map((item, index) => (
      <div
        className={`onBoardingImage ${
          index === this.state.realIndex && "active"
        }`}
        style={{
          backgroundImage: `url("${item.image}")`,
        }}
        key={index}
      />
    ));
  }

  private _renderScreenLem() {
    return onBoardingScreens.map((item, index) => {
      const Lem = item.lem;
      return (
        <div
          className={`onBoardingLem ${
            index === this.state.realIndex && "active"
          }`}
          key={index}
        >
          <Lem />
        </div>
      );
    });
  }

  private _renderScreenCardIamge() {
    return onBoardingScreens.map((item, index) => (
      <div
        className={` onBoardingCardImage ${
          index === this.state.realIndex && "active"
        }`}
        style={{
          backgroundImage: `url("${item.cardImage}")`,
        }}
        key={index}
      />
    ));
  }

  private _renderPaginationBullets() {
    return onBoardingScreens.map((item, index) => (
      <div
        className={` paginationBullet ${
          index === this.state.realIndex && "active"
        }`}
        key={index}
      />
    ));
  }

  private _hideOnBoarding() {
    const event = new CustomEvent("closeOnBoardingScreen", {});
    document.dispatchEvent(event);
  }

  private _swipeToNext() {
    this._swiper.slideNext();
  }
}
